import BaseFormItem from "../BaseFormItem";
import Control from "lib/common/descriptorcontrols/IntegerField/label";
import React from "react";

export class IntegerFieldlabel extends BaseFormItem {
    render() {
        const {activeRecord, descriptor} = this.props;
        return <Control {...this.getPlumbingProps()}
                        value={activeRecord.get(descriptor.key)}
                        enabled={activeRecord.isFieldEnabled(descriptor.key)}
        />;
    }

}

export default IntegerFieldlabel;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/IntegerField/label.js